import { render, staticRenderFns } from "./TopUI.vue?vue&type=template&id=167dfed8&scoped=true&"
import script from "./TopUI.vue?vue&type=script&lang=js&"
export * from "./TopUI.vue?vue&type=script&lang=js&"
import style0 from "./TopUI.vue?vue&type=style&index=0&id=167dfed8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167dfed8",
  null
  
)

export default component.exports